import { useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  isStoryWorkspaceModeLive,
  type StoryWorkspaceModeId,
} from "../components/registry/storyWorkspaceModes";

const DEFAULT_PRESENT_TAB = "story";
const MODE_SUFFIX = /\/(build|present|explore)\/?$/;

/**
 * The story workspace mode, derived from the route (`…/present` is present, `…/explore` is explore, anything else is
 * build). One state for the top bar switch and the tool bar. Present keeps the last `?tab=`.
 */
export const useStoryWorkspaceMode = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const mode: StoryWorkspaceModeId = /\/present\/?$/.test(pathname)
    ? "present"
    : /\/explore\/?$/.test(pathname)
      ? "explore"
      : "build";
  const lastTab = useRef(DEFAULT_PRESENT_TAB);
  if (mode === "present") {
    lastTab.current = new URLSearchParams(search).get("tab") || lastTab.current;
  }

  const setMode = useCallback(
    (next: StoryWorkspaceModeId) => {
      if (!isStoryWorkspaceModeLive(next) || next === mode) return;
      const base = pathname.replace(MODE_SUFFIX, "");
      navigate(next === "present" ? `${base}/present?tab=${lastTab.current}` : `${base}/${next}`);
    },
    [mode, navigate, pathname],
  );

  return { mode, setMode };
};
